/** zh-CN catalogue `skin` (W3-09; English: src/render/skin/skin.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'skin',
  locale: 'zh-CN',
  messages: {
    notReady: '皮肤仍在加载中，请稍后再试。',
    imageUndecodable: '此浏览器无法读取皮肤中的图片 {file}。',
    storageFailed: '无法在此浏览器中保存皮肤：{detail}',
    storageListFailed: '无法从此浏览器读取已安装的皮肤：{detail}',
    unknownSkin: '此浏览器中未安装该皮肤，它可能已被移除。',
    localMissing: '本地文件中的 Phigros 皮肤不可用。',
    builtinNotRemovable: '内置皮肤无法移除。',
    storedInvalid: '已安装的皮肤“{name}”已损坏，无法使用。',
    storedUnreadable: '无法从此浏览器读取已安装的皮肤“{name}”：{detail}',
    localInvalid: '本地文件中的 Phigros 皮肤无法使用：发现 {count, plural, other {# 个问题}}。',
    localUnreachable: '无法加载本地文件中的 Phigros 皮肤：{detail}',
    proceduralFailed: '无法创建由 Phiedit 绘制的皮肤：{detail}',
    defaultUnavailable: '无法加载所选皮肤“{name}”，已改用其他皮肤。',
    defaultMissing: '设置中选择的皮肤不可用，已改用其他皮肤。',
    initFailed: '无法加载皮肤：{detail}',
  },
};

export default catalog;
